import { Injectable } from '@angular/core';
import { DirtyComponent } from '@shared/models';

@Injectable({
  providedIn: 'root'
})
export class DataLossService {
  private dirtyComponents: DirtyComponent[] = [];

  public addComponentToCheckUnsavedChanges(component: DirtyComponent) {
    const componentInList = this.dirtyComponents.find(
      (x) =>
        x.componentDetail.componentName ===
        component.componentDetail.componentName
    );
    if (!componentInList) {
      this.dirtyComponents.push(component);
    }
  }

  public removeComponentFromUnsavedChanges(component: DirtyComponent = null) {
    if (component) {
      this.dirtyComponents = this.dirtyComponents.filter(
        (x) =>
          x.componentDetail.componentName !==
          component.componentDetail.componentName
      );
    } else {
      this.dirtyComponents = [];
    }
  }

  public checkForUnsavedChanges(forComponent: DirtyComponent = null) {
    if (this.isDirty(forComponent)) {
      const response = confirm(
        'You have unsaved changes pending, are you sure you wish to continue?'
      );
      if (response === true) {
        if (forComponent) {
          forComponent.resetData();
          this.dirtyComponents = this.dirtyComponents.filter(
            (x) =>
              x.componentDetail.componentName !==
              forComponent.componentDetail.componentName
          );
        } else {
          this.dirtyComponents.forEach((x) => x.resetData());
          this.dirtyComponents = [];
        }
      }
      return response;
    }
    return true;
  }

  public isDirty(formToCheck: DirtyComponent = null) {
    let result = formToCheck !== null;

    if (result) {
      result = formToCheck.componentDetail.formNameToCheckForDirtyness
        ? this.dirtyComponents &&
          this.dirtyComponents.filter(
            (x) =>
              x.componentDetail.componentName ===
              formToCheck.componentDetail.componentName
          ).length > 0 &&
          formToCheck[formToCheck.componentDetail.formNameToCheckForDirtyness]
            .dirty
        : formToCheck.componentDetail.isFieldDirty === true
          ? true
          : false;
    } else {
      result =
        this.dirtyComponents &&
        this.dirtyComponents.filter(
          (x) =>
            (x.componentDetail.formNameToCheckForDirtyness &&
              x[x.componentDetail.formNameToCheckForDirtyness].dirty) ||
            x.componentDetail.isFieldDirty
        ).length > 0;
    }
    return result;
  }
}
